module.exports = __webpack_public_path__ + "assets/img/不良待决策.982009b2.svg";